export function tryParse<T>(val: any): T | null {
  try {
    return JSON.parse(val)
  } catch (error) {
    return null
  }
}
